import { useState, useEffect, useRef } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { ESTILO_BOTON_GENERAL_ACEPTAR, ESTILO_BOTON_GENERAL_CANCELAR, ESTILO_BOTON_LISTAR_NUEVO, ESTILO_INPUT_GENERICO } from "../../../utils/const/estilos-const";
import "../../../style/style-cargando.css";
import Select from "react-select";
import ArrowBack from "../../../components/arrow-back";
import { useTranslation } from "react-i18next";
import ProcessingDialog from "../../../components/processing-dialog";
import ToastComponent from "../../../components/toast-component";
import ModalTelefono from "../../../components/modal-telefono";
import Spinner from "../../../components/spinner";
import { actualizarCliente, actualizarEmailCliente, actualizarTelefonoCliente, agregarEmailCliente, agregarTelefonoCliente, crearCliente, deshabilitarEmailCliente, deshabilitarTelefonoCliente, habilitarEmailCliente, habilitarTelefonoCliente } from "../../../api/api-cliente";
import cargandoCard from "../../../components/cargando-card";
import { obtenerListaGrupoCliente } from "../../../api/api-grupo-cliente";
import { obtenerListaPais } from "../../../api/api-pais";
import { obtenerListaCiudad, obtenerListaCiudadPorPais } from "../../../api/api-ciudad";
import { COLOR_VERDE_MAIN } from "../../../utils/const/colors-const";
import ModalEmail from "../../../components/modal-email";
import moment from "moment";
import { obtenerListaTipoCliente } from "../../../api/api-tipo-cliente";
import { obtenerGeocercas } from "../../../api/api-grupo-geocerca";

let $ = window.$;

export default function ClientePage() {
  const location = useLocation();
  const history = useHistory();
  const { t } = useTranslation();
  const [cargandoPage, setCargandoPage] = useState(true);
  const [formData, setFormData] = useState(null);
  const [titulo, setTitulo] = useState("");
  const [listaGrupoCliente, setListaGrupoCliente] = useState([]);
  const [grupoClienteSelected, setGrupoClienteSelected] = useState(null);
  const [listaCiudad, setListaCiudad] = useState([]);
  const [ciudadSelected, setCiudadSelected] = useState(null);
  const [listaPais, setListaPais] = useState([]);
  const [paisSelected, setPaisSelected] = useState(null);
  const [listaTipoCliente, setListaTipoCliente] = useState([]);
  const [tipoClienteSelected, setTipoClienteSelected] = useState(null);
  const [listaGeocercas, setListaGeocercas] = useState([]);
  const [geocercaSelected, setGeocercaSelected] = useState(null);

  const [processingVisible, setProcessingVisible] = useState(false);
  const [toastVisible, setToastVisible] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastType, setToastType] = useState("warning");
  const [map, setMap] = useState(null);
  const [marker, setMarker] = useState(null);
  const markerRef = useRef(null);
  const geofenceRef = useRef(null);
  const formDataRef = useRef(null);
  // const telefonoHandlersRef = useRef({
  //   modificar: null,
  //   deshabilitar: null,
  //   habilitar: null,
  // });
  // const emailHandlersRef = useRef({
  //   modificar: null,
  //   deshabilitar: null,
  //   habilitar: null,
  // });

  const [rowsDataTelefonos, setRowsDataTelefonos] = useState([]);

  const [showModalTelefono, setShowModalTelefono] = useState(false);
  const [telefonoFormData, setTelefonoFormData] = useState({
    codigo: "",
    descripcion: "",
    nota: "",
  });

  const [rowsDataEmail, setRowsDataEmail] = useState([]);

  const [emailFormData, setEmailFormData] = useState({
    codigo: "",
    descripcion: "",
    nota: "",
  });
  const [showModalEmail, setShowModalEmail] = useState(false);

  const [requestSend, setRequestSend] = useState(false);

  // Keep formDataRef in sync with formData
  useEffect(() => {
    formDataRef.current = formData;
  }, [formData]);

  useEffect(() => {
    iniciar();
  }, []);

  useEffect(() => {
    if (!cargandoPage && formData && window.google && window.google.maps) {
      // Small delay to ensure DOM is ready
      const timer = setTimeout(() => {
        initializeMap();
      }, 100);
      return () => {
        clearTimeout(timer);
        // Cleanup marker on unmount
        if (markerRef.current) {
          markerRef.current.setMap(null);
          markerRef.current = null;
        }
        // Cleanup geofence on unmount
        if (geofenceRef.current) {
          geofenceRef.current.setMap(null);
          geofenceRef.current = null;
        }
      };
    }
    return () => {
      // Cleanup marker on unmount
      if (markerRef.current) {
        markerRef.current.setMap(null);
        markerRef.current = null;
      }
      // Cleanup geofence on unmount
      if (geofenceRef.current) {
        geofenceRef.current.setMap(null);
        geofenceRef.current = null;
      }
    };
  }, [cargandoPage, formData?.id]);

  // Update marker position when latitud/longitud inputs change manually
  useEffect(() => {
    if (map && formData?.latitud && formData?.longitud) {
      const lat = parseFloat(formData.latitud);
      const lng = parseFloat(formData.longitud);

      // Validate coordinates are numbers and within valid ranges
      if (!isNaN(lat) && !isNaN(lng) &&
        lat >= -90 && lat <= 90 &&
        lng >= -180 && lng <= 180) {
        const newLocation = new window.google.maps.LatLng(lat, lng);

        if (markerRef.current) {
          // Marker exists, update its position
          const currentPos = markerRef.current.getPosition();

          // Only update if the position is different (to avoid infinite loops)
          if (!currentPos ||
            Math.abs(currentPos.lat() - lat) > 0.000001 ||
            Math.abs(currentPos.lng() - lng) > 0.000001) {
            markerRef.current.setPosition(newLocation);
            map.setCenter(newLocation);
          }
        } else {
          // Marker doesn't exist, create one
          placeMarker(newLocation, map);
          map.setCenter(newLocation);
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData?.latitud, formData?.longitud]);

  // Update marker color when color input changes
  useEffect(() => {
    if (markerRef.current && window.google && window.google.maps) {
      // Default to red if color is empty, invalid, or not provided
      let validColor = '#FF0000';

      if (formData?.color) {
        // Check if color is valid hex format
        if (/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/.test(formData.color)) {
          validColor = formData.color;
        }
        // If invalid, keep default red
      }
      // If empty, keep default red

      // Update marker icon with the color (red if invalid/empty, or user's color if valid)
      const newIcon = getMarkerIcon(validColor);
      if (newIcon) {
        markerRef.current.setIcon(newIcon);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData?.color]);

  useEffect(() => {
    if (!map || !window.google || !window.google.maps) {
      return;
    }

    // Remove existing geofence if any
    if (geofenceRef.current) {
      geofenceRef.current.setMap(null);
      geofenceRef.current = null;
    }

    if (geocercaSelected !== null && geocercaSelected.coordenadas) {
      // Show geocercaSelected.coordenadas has the geofence, I'd like to show that geofence in the map
      try {
        const coordenadas = geocercaSelected.coordenadas;

        // Validate and use geocerca color, default to red if invalid
        let color = '#FF0000';
        if (geocercaSelected.colorGeocerca) {
          const colorValue = geocercaSelected.colorGeocerca;
          // Check if color is valid hex format
          if (/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/.test(colorValue)) {
            color = colorValue;
          }
        }

        // Helper function to parse coordinate object {x, y} where x is latitude and y is longitude
        const parseCoordinate = (coord) => {
          if (typeof coord === 'object' && coord !== null) {
            if (coord.x !== undefined && coord.y !== undefined) {
              const lat = parseFloat(coord.x);
              const lng = parseFloat(coord.y);

              // Validate that we have valid numbers
              if (!isNaN(lat) && !isNaN(lng) &&
                isFinite(lat) && isFinite(lng) &&
                lat >= -90 && lat <= 90 &&
                lng >= -180 && lng <= 180) {
                return new window.google.maps.LatLng(lat, lng);
              }
            }
          }
          console.warn('Invalid coordinate:', coord);
          return null;
        };

        // Handle coordenadas structure: array of arrays of coordinate objects
        // Format: [[{x, y}, {x, y}, ...], ...]
        if (Array.isArray(coordenadas) && coordenadas.length > 0) {
          // Check if first element is an array (nested structure)
          if (Array.isArray(coordenadas[0])) {
            // Handle array of paths: [[{x, y}, ...], [{x, y}, ...], ...]
            // For now, we'll use the first path (main geofence)
            const firstPath = coordenadas[0];

            if (Array.isArray(firstPath) && firstPath.length > 0) {
              // Parse all coordinates in the path
              const path = firstPath.map(parseCoordinate).filter(coord => coord !== null);

              if (path.length > 0) {
                const polygon = new window.google.maps.Polygon({
                  paths: path,
                  strokeColor: color,
                  strokeOpacity: 0.8,
                  strokeWeight: 2,
                  fillColor: color,
                  fillOpacity: 0.35,
                  map: map
                });
                geofenceRef.current = polygon;

                // Fit map to show the entire geofence
                const bounds = new window.google.maps.LatLngBounds();
                path.forEach(latLng => bounds.extend(latLng));
                map.fitBounds(bounds);
              } else {
                console.error('No valid coordinates found in the first path');
              }
            } else {
              console.error('First path is empty or not an array');
            }
          } else {
            // Handle flat array of coordinate objects: [{x, y}, {x, y}, ...]
            const path = coordenadas.map(parseCoordinate).filter(coord => coord !== null);

            if (path.length > 0) {
              const polygon = new window.google.maps.Polygon({
                paths: path,
                strokeColor: color,
                strokeOpacity: 0.8,
                strokeWeight: 2,
                fillColor: color,
                fillOpacity: 0.35,
                map: map
              });
              geofenceRef.current = polygon;

              // Fit map to show the entire geofence
              const bounds = new window.google.maps.LatLngBounds();
              path.forEach(latLng => bounds.extend(latLng));
              map.fitBounds(bounds);
            } else {
              console.error('No valid coordinates found in coordenadas array');
            }
          }
        } else if (coordenadas.center && coordenadas.radius) {
          // Handle circle format: {center: {x, y}, radius: number}
          const centerLat = parseFloat(coordenadas.center.x || coordenadas.center.lat || coordenadas.center.latitud);
          const centerLng = parseFloat(coordenadas.center.y || coordenadas.center.lng || coordenadas.center.longitud);
          const radius = parseFloat(coordenadas.radius);

          if (!isNaN(centerLat) && !isNaN(centerLng) && !isNaN(radius) &&
            isFinite(centerLat) && isFinite(centerLng) && isFinite(radius) &&
            centerLat >= -90 && centerLat <= 90 &&
            centerLng >= -180 && centerLng <= 180 &&
            radius > 0) {
            const center = new window.google.maps.LatLng(centerLat, centerLng);
            const circle = new window.google.maps.Circle({
              center: center,
              radius: radius,
              strokeColor: color,
              strokeOpacity: 0.8,
              strokeWeight: 2,
              fillColor: color,
              fillOpacity: 0.35,
              map: map
            });
            geofenceRef.current = circle;

            // Fit map to show the entire circle
            const bounds = circle.getBounds();
            if (bounds) {
              map.fitBounds(bounds);
            }
          } else {
            console.error('Invalid circle center or radius');
          }
        } else {
          console.warn('Unknown coordenadas format:', coordenadas);
        }
      } catch (err) {
        console.error('Error displaying geofence:', err);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [geocercaSelected, map]);

  const iniciar = async () => {
    try {
      const data = location.state;
      // console.log("data");
      // console.log(data);
      if (data !== undefined && data !== null) {
        setFormData(data.params);
        setTitulo(data.titulo);
      }
      const grupoCliente = await obtenerListaGrupoCliente({ habilitado: 1 }, true);
      // console.log("grupoCliente");
      // console.log(grupoCliente);
      setListaGrupoCliente(grupoCliente);
      if (data.params.idGrupoCliente !== undefined && data.params.idGrupoCliente !== null) {
        const grupoClienteSelected = grupoCliente.find((item) => item.value === data.params.idGrupoCliente);
        // console.log("grupoClienteSelected");
        // console.log(grupoClienteSelected);
        setGrupoClienteSelected(grupoClienteSelected !== undefined ? grupoClienteSelected : null);
      }
      const pais = await obtenerListaPais({ habilitado: 1 }, true);
      // console.log("pais");
      // console.log(pais);
      setListaPais(pais);
      if (data.params.idPais !== undefined && data.params.idPais !== null) {
        const paisSelected = pais.find((item) => item.value === data.params.idPais);
        // console.log("paisSelected");
        // console.log(paisSelected);
        setPaisSelected(paisSelected !== undefined ? paisSelected : null);
      }
      const ciudad = await obtenerListaCiudad({ habilitado: 1 }, true);
      setListaCiudad(ciudad);
      if (data.params.idCiudad !== undefined && data.params.idCiudad !== null) {
        const ciudadSelected = ciudad.find((item) => item.value === data.params.idCiudad);
        // console.log("ciudadSelected");
        // console.log(ciudadSelected);
        setCiudadSelected(ciudadSelected !== undefined ? ciudadSelected : null);
      }


      const tipoCliente = await obtenerListaTipoCliente({ habilitado: 1 }, true);
      setListaTipoCliente(tipoCliente);
      if (data.params.idTipoCliente !== undefined && data.params.idTipoCliente !== null) {
        const tipoClienteSelected = tipoCliente.find((item) => item.value === data.params.idTipoCliente);
        // console.log("tipoClienteSelected");
        // console.log(tipoClienteSelected);
        setTipoClienteSelected(tipoClienteSelected !== undefined ? tipoClienteSelected : null);
      }

      if (Array.isArray(data.params.telefonoCliente)) {
        for (let i = 0; i < data.params.telefonoCliente.length; i++) {
          const element = data.params.telefonoCliente[i];
          data.params.telefonoCliente[i].fechaProceso = moment(element.fechaProceso).format("YYYY-MM-DD HH:mm:ss");
        }
        setRowsDataTelefonos(data.params.telefonoCliente);
      }
      if (Array.isArray(data.params.emailCliente)) {
        for (let i = 0; i < data.params.emailCliente.length; i++) {
          const element = data.params.emailCliente[i];
          data.params.emailCliente[i].fechaProceso = moment(element.fechaProceso).format("YYYY-MM-DD HH:mm:ss");
        }
        setRowsDataEmail(data.params.emailCliente);
      }
      const geocercas = await obtenerGeocercas();
      // console.log("geocercas");
      // console.log(geocercas);
      setListaGeocercas(geocercas.body);
      if (data.params.idGeocerca !== undefined && data.params.idGeocerca !== null) {
        const geocerca = geocercas.body.find((item) => item.value === data.params.idGeocerca);
        setGeocercaSelected(geocerca);
      }
    } catch (err) {
      console.log('iniciar err');
      console.log(err);
    } finally {
      setCargandoPage(false);
    }
  };

  const charLimits = {
    codigo: 64,
    descripcion: 512,
    nota: 1024,
    latitud: 16,
    longitud: 16,
    color: 7,
    distanciaAlerta: 3,
  };

  useEffect(() => {
    if (cargandoPage) {
      return;
    }
    // Small delay to ensure DOM is ready
    const timer = setTimeout(() => {
      const gridElement = $("#gridContainerTelefonos");
      if (gridElement.length) {
        try {
          const gridInstance = gridElement.dxDataGrid("instance");
          if (gridInstance) {
            // Grid already exists, just update the data source
            gridInstance.option("dataSource", rowsDataTelefonos);
            // Reapply scrollbar CSS
            applyScrollbarCSS(gridElement);
          } else {
            // Grid doesn't exist yet, initialize it
            inicializarGridTelefonos();
          }
        } catch (e) {
          // Grid doesn't exist yet, initialize it
          inicializarGridTelefonos();
        }
      }
    }, 100);

    return () => clearTimeout(timer);
  }, [rowsDataTelefonos, cargandoPage]);

  const applyScrollbarCSS = (gridElement) => {
    // Force scrollbars to always be visible on DevExtreme scrollable container
    setTimeout(() => {
      // Target the main scrollable container
      const scrollableContainer = gridElement.find('.dx-scrollable');
      if (scrollableContainer.length) {
        scrollableContainer.css({
          'overflow-x': 'scroll',
          'overflow-y': 'scroll'
        });
      }
      // Also target the scrollable content wrapper
      const scrollableContent = gridElement.find('.dx-scrollable-content');
      if (scrollableContent.length) {
        scrollableContent.parent().css({
          'overflow-x': 'scroll',
          'overflow-y': 'scroll'
        });
      }
      // Target the data grid's scrollable wrapper
      const dataGridScrollable = gridElement.find('.dx-datagrid-rowsview');
      if (dataGridScrollable.length) {
        dataGridScrollable.parent().css({
          'overflow-x': 'scroll',
          'overflow-y': 'scroll'
        });
      }
    }, 100);
  };

  const inicializarGridTelefonos = () => {
    try {
      const gridElement = $("#gridContainerTelefonos");

      // Check if element exists
      if (!gridElement.length) {
        // console.warn("Grid container element not found");
        return;
      }

      // Initialize the grid
      gridElement.dxDataGrid({
        dataSource: rowsDataTelefonos,
        paging: {
          pageSize: 20,
        },
        pager: {
          showPageSizeSelector: true,
          allowedPageSizes: [50, 100, 150, 200],
        },
        scrolling: {
          mode: "standard",
          showScrollbar: "always",
          useNative: true,
        },
        remoteOperations: false,
        groupPanel: { visible: true },
        grouping: {
          autoExpandAll: false,
        },
        allowColumnReordering: true,
        rowAlternationEnabled: true,
        showBorders: true,
        columnAutoWidth: true,
        filterRow: {
          visible: true,
          applyFilter: "auto",
        },
        searchPanel: {
          visible: true,
          width: 240,
          placeholder: t("grilla_placeholderbuscar"),
        },
        export: {
          enabled: true,
        },
        headerFilter: {
          visible: true,
        },
        columns: [
          {
            dataField: "acciones",
            caption: t("column_acciones"),
            width: 200,
            allowFiltering: false,
            allowSorting: false,
            cellTemplate: function (container, options) {
              // console.log("cellTemplate acciones");
              // console.log('options', options);
              // console.log('options.data', options.data);
              const buttonContainer = $("<div>").addClass("flex gap-2");
              // Edit button
              $("<button>")
                .addClass(
                  "px-3 py-1 bg-blue-500 hover:bg-blue-600 text-white rounded text-sm"
                )
                .text(t("column_modificar"))
                .on("click", function () {
                  // Get the latest handler from ref
                  // const handler = telefonoHandlersRef.current?.modificar;
                  // if (handler) {
                  //   handler(options.data);
                  // } else {
                  //   console.error('modificarTelefonoSelected handler not found');
                  // }
                  modificarTelefonoSelected(options.data);
                })
                .appendTo(buttonContainer);

              // Delete button
              if (options.data.habilitado === 1) {
                $("<button>")
                  .addClass(
                    "px-3 py-1 bg-red-500 hover:bg-red-600 text-white rounded text-sm"
                  )
                  .text(t("column_deshabilitar"))
                  .on("click", function () {
                    // if (telefonoHandlersRef.current && telefonoHandlersRef.current.deshabilitar) {
                    //   telefonoHandlersRef.current.deshabilitar(options.data);
                    // }
                    deshabilitarTelefonoSelected(options.data);
                  })
                  .appendTo(buttonContainer);
              }
              if (options.data.habilitado === 0) {
                $("<button>")
                  .addClass(
                    `px-3 py-1 bg-[${COLOR_VERDE_MAIN}] hover:bg-[#006600] text-white rounded text-sm`
                  )
                  .text(t("column_habilitar"))
                  .on("click", function () {
                    // if (telefonoHandlersRef.current && telefonoHandlersRef.current.habilitar) {
                    //   telefonoHandlersRef.current.habilitar(options.data);
                    // }
                    habilitarTelefonoSelected(options.data);
                  })
                  .appendTo(buttonContainer);
              }

              buttonContainer.appendTo(container);
            },
          },
          {
            dataField: "id",
            caption: "ID",
            visible: false,
          },
          {
            dataField: "codigo",
            caption: t("column_codigo"),
            visible: true,
          },
          {
            dataField: "descripcion",
            caption: t("column_descripcion"),
            visible: true,
          },
          {
            dataField: "nota",
            caption: t("column_nota"),
            width: 150,
          },
          {
            dataField: "fechaProceso",
            caption: t("column_fechaProceso"),
            width: 200,
          },
          {
            dataField: "habilitadoLabel",
            caption: t("column_estado"),
            width: 200,
          }
        ],
      });

      // Force scrollbars to always be visible
      applyScrollbarCSS(gridElement);
    } catch (err) {
      console.error("Error initializing grid telefonos:", err);
    }
  };

  const modificarTelefonoSelected = (data) => {
    try {
      // console.log('modificarTelefonoSelected');
      // console.log(data);
      setTelefonoFormData(data);
      setShowModalTelefono(true);
    } catch (err) {
      console.log('modificarTelefonoSelected err');
      console.log(err);
    }
  };

  const deshabilitarTelefonoSelected = async (data) => {
    try {
      // console.log('deshabilitarTelefonoSelected');
      // console.log(data);
      // console.log('formData');
      // console.log(formData);
      if (data.id < 0) {
        // console.log('eliminar de la grid porque es un numero negativo');
        setRowsDataTelefonos(rowsDataTelefonos.filter(item => item.id !== data.id));
      } else {
        // console.log('deshabilitar en la base');
        setProcessingVisible(true);
        const response = await deshabilitarTelefonoCliente(data);
        setProcessingVisible(false);
        if (response.error === false) {
          showToast(t("alert_se_deshabilito_correctamente"));
        } else {
          showToast(response.message);
          return;
        }
        data.habilitado = 0;
        data.habilitadoLabel = t("column_deshabilitado");
        setRowsDataTelefonos(rowsDataTelefonos.map(item => item.id === data.id ? data : item));
      }
    } catch (err) {
      console.log('deshabilitarTelefonoSelected err');
      console.log(err);
    }
  };

  const habilitarTelefonoSelected = async (data) => {
    try {
      // console.log('habilitarTelefonoSelected');
      // console.log(data);
      setProcessingVisible(true);
      const response = await habilitarTelefonoCliente(data);
      setProcessingVisible(false);
      if (response.error === false) {
        showToast(t("alert_se_habilito_correctamente"));
        data.habilitado = 1;
        data.habilitadoLabel = t("column_habilitado");
        setRowsDataTelefonos(rowsDataTelefonos.map(item => item.id === data.id ? data : item));
      } else {
        showToast(response.message);
        return;
      }
    } catch (err) {
      console.log('habilitarTelefonoSelected err');
      console.log(err);
    }
  };

  useEffect(() => {
    if (cargandoPage) {
      return;
    }
    // Small delay to ensure DOM is ready
    const timer = setTimeout(() => {
      const gridElement = $("#gridContainerEmail");
      if (gridElement.length) {
        try {
          const gridInstance = gridElement.dxDataGrid("instance");
          if (gridInstance) {
            // Grid already exists, just update the data source
            gridInstance.option("dataSource", rowsDataEmail);
            // Reapply scrollbar CSS
            applyScrollbarCSS(gridElement);
          } else {
            // Grid doesn't exist yet, initialize it
            inicializarGridEmail();
          }
        } catch (e) {
          // Grid doesn't exist yet, initialize it
          inicializarGridEmail();
        }
      }
    }, 100);

    return () => clearTimeout(timer);
  }, [rowsDataEmail, cargandoPage]);

  const inicializarGridEmail = () => {
    try {
      const gridElement = $("#gridContainerEmail");

      // Check if element exists
      if (!gridElement.length) {
        // console.warn("Grid container element not found");
        return;
      }

      // Initialize the grid
      gridElement.dxDataGrid({
        dataSource: rowsDataEmail,
        paging: {
          pageSize: 20,
        },
        pager: {
          showPageSizeSelector: true,
          allowedPageSizes: [50, 100, 150, 200],
        },
        scrolling: {
          mode: "standard",
          showScrollbar: "always",
          useNative: true,
        },
        remoteOperations: false,
        groupPanel: { visible: true },
        grouping: {
          autoExpandAll: false,
        },
        allowColumnReordering: true,
        rowAlternationEnabled: true,
        showBorders: true,
        columnAutoWidth: true,
        filterRow: {
          visible: true,
          applyFilter: "auto",
        },
        searchPanel: {
          visible: true,
          width: 240,
          placeholder: t("grilla_placeholderbuscar"),
        },
        export: {
          enabled: true,
        },
        headerFilter: {
          visible: true,
        },
        columns: [
          {
            dataField: "acciones",
            caption: t("column_acciones"),
            width: 200,
            allowFiltering: false,
            allowSorting: false,
            cellTemplate: function (container, options) {
              // console.log("cellTemplate acciones");
              // console.log('options', options);
              // console.log('options.data', options.data);
              const buttonContainer = $("<div>").addClass("flex gap-2");
              // Edit button
              $("<button>")
                .addClass(
                  "px-3 py-1 bg-blue-500 hover:bg-blue-600 text-white rounded text-sm"
                )
                .text(t("column_modificar"))
                .on("click", function () {
                  // Get the latest handler from ref
                  // const handler = emailHandlersRef.current?.modificar;
                  // if (handler) {
                  //   handler(options.data);
                  // } else {
                  //   console.error('modificarEmailSelected handler not found');
                  // }
                  modificarEmailSelected(options.data);
                })
                .appendTo(buttonContainer);

              // Delete button
              if (options.data.habilitado === 1) {
                $("<button>")
                  .addClass(
                    "px-3 py-1 bg-red-500 hover:bg-red-600 text-white rounded text-sm"
                  )
                  .text(t("column_deshabilitar"))
                  .on("click", function () {
                    // const handler = emailHandlersRef.current?.deshabilitar;
                    // if (handler) {
                    //   handler(options.data);
                    // } else {
                    //   console.error('deshabilitarEmailSelected handler not found');
                    // }
                    deshabilitarEmailSelected(options.data);
                  })
                  .appendTo(buttonContainer);
              }
              if (options.data.habilitado === 0) {
                $("<button>")
                  .addClass(
                    `px-3 py-1 bg-[${COLOR_VERDE_MAIN}] hover:bg-[#006600] text-white rounded text-sm`
                  )
                  .text(t("column_habilitar"))
                  .on("click", function () {
                    // const handler = emailHandlersRef.current?.habilitar;
                    // if (handler) {
                    //   handler(options.data);
                    // } else {
                    //   console.error('habilitarEmailSelected handler not found');
                    // }
                    habilitarEmailSelected(options.data);
                  })
                  .appendTo(buttonContainer);
              }

              buttonContainer.appendTo(container);
            },
          },
          {
            dataField: "id",
            caption: "ID",
            visible: false,
          },
          {
            dataField: "codigo",
            caption: t("column_codigo"),
            visible: true,
          },
          {
            dataField: "descripcion",
            caption: t("column_descripcion"),
            visible: true,
          },
          {
            dataField: "nota",
            caption: t("column_nota"),
            width: 150,
          },
          {
            dataField: "fechaProceso",
            caption: t("column_fechaProceso"),
            width: 200,
          },
          {
            dataField: "habilitadoLabel",
            caption: t("column_estado"),
            width: 200,
          }
        ],
      });

      // Force scrollbars to always be visible
      applyScrollbarCSS(gridElement);
    } catch (err) {
      console.error("Error initializing grid email:", err);
    }
  };

  const modificarEmailSelected = (data) => {
    try {
      // console.log('modificarEmailSelected');
      // console.log(data);
      setEmailFormData(data);
      setShowModalEmail(true);
    } catch (err) {
      console.log('modificarEmailSelected err');
      console.log(err);
    }
  };

  const deshabilitarEmailSelected = async (data) => {
    try {
      // console.log('deshabilitarEmailSelected');
      // console.log(data);
      if (data.id < 0) {
        setRowsDataEmail(rowsDataEmail.filter(item => item.id !== data.id));
      } else {
        // console.log('deshabilitar en la base');
        setProcessingVisible(true);
        const response = await deshabilitarEmailCliente(data);
        setProcessingVisible(false);
        if (response.error === false) {
          showToast(t("alert_se_deshabilito_correctamente"));
        } else {
          showToast(response.message);
          return;
        }
        data.habilitado = 0;
        data.habilitadoLabel = t("column_deshabilitado");
        setRowsDataEmail(rowsDataEmail.map(item => item.id === data.id ? data : item));
      }
    } catch (err) {
      console.log('deshabilitarEmailSelected err');
      console.log(err);
    }
  };
  // emailHandlersRef.current.deshabilitar = deshabilitarEmailSelected;

  const habilitarEmailSelected = async (data) => {
    try {
      // console.log('habilitarEmailSelected');
      // console.log(data);
      setProcessingVisible(true);
      const response = await habilitarEmailCliente(data);
      setProcessingVisible(false);
      if (response.error === false) {
        showToast(t("alert_se_habilito_correctamente"));
        data.habilitado = 1;
        data.habilitadoLabel = t("column_habilitado");
        setRowsDataEmail(rowsDataEmail.map(item => item.id === data.id ? data : item));
      } else {
        showToast(response.message);
        return;
      }
    } catch (err) {
      console.log('habilitarEmailSelected err');
      console.log(err);
    }
  };
  // emailHandlersRef.current.habilitar = habilitarEmailSelected;

  useEffect(() => {
    if (paisSelected !== null) {
      obtenerListaCiudadXPais(paisSelected.value);
    }
    if (paisSelected === null) {
      setListaCiudad([]);
      setCiudadSelected(null);
    }
  }, [paisSelected]);

  const obtenerListaCiudadXPais = async (idPais) => {
    try {
      setProcessingVisible(true);
      const ciudad = await obtenerListaCiudadPorPais({ idPais: idPais }, true, t);
      setListaCiudad(ciudad);
    } catch (err) {
      console.log('obtenerListaCiudadXPais err');
      console.log(err);
    } finally {
      setProcessingVisible(false);
    }
  };

  const initializeMap = () => {
    if (!window.google || !window.google.maps) {
      console.warn('Google Maps API not loaded yet');
      return;
    }

    const mapElement = document.getElementById('mapa');
    if (!mapElement) {
      return;
    }

    // Clear any existing marker before initializing new map
    if (markerRef.current) {
      markerRef.current.setMap(null);
      markerRef.current = null;
    }
    // Clear any existing geofence before initializing new map
    if (geofenceRef.current) {
      geofenceRef.current.setMap(null);
      geofenceRef.current = null;
    }

    // Get user's current location
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const userLocation = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          };

          // Initialize map centered on user location
          const googleMap = new window.google.maps.Map(mapElement, {
            center: userLocation,
            zoom: 15,
            mapTypeControl: true,
            streetViewControl: true,
            fullscreenControl: true,
          });

          setMap(googleMap);

          // If formData has existing coordinates, place marker there
          if (formData.latitud && formData.longitud) {
            const existingLocation = {
              lat: parseFloat(formData.latitud),
              lng: parseFloat(formData.longitud),
            };
            placeMarker(existingLocation, googleMap);
            googleMap.setCenter(existingLocation);
          }

          // Add click event listener to place marker
          googleMap.addListener('click', (event) => {
            const clickedLocation = {
              lat: event.latLng.lat(),
              lng: event.latLng.lng(),
            };
            placeMarker(clickedLocation, googleMap);

            // Update form inputs - use functional update to preserve all fields including color
            setFormData(prev => ({
              ...prev,
              latitud: clickedLocation.lat.toFixed(6),
              longitud: clickedLocation.lng.toFixed(6),
            }));
          });
        },
        (error) => {
          console.error('Error getting user location:', error);
          // Default to Bolivia's center if geolocation fails
          const boliviaCenter = { lat: -16.5000, lng: -63.6000 };
          const googleMap = new window.google.maps.Map(mapElement, {
            center: boliviaCenter,
            zoom: 6,
            mapTypeControl: true,
            streetViewControl: true,
            fullscreenControl: true,
          });
          setMap(googleMap);

          // If formData has existing coordinates, place marker there
          if (formData.latitud && formData.longitud) {
            const existingLocation = {
              lat: parseFloat(formData.latitud),
              lng: parseFloat(formData.longitud),
            };
            placeMarker(existingLocation, googleMap);
            googleMap.setCenter(existingLocation);
          }

          // Add click event listener
          googleMap.addListener('click', (event) => {
            const clickedLocation = {
              lat: event.latLng.lat(),
              lng: event.latLng.lng(),
            };
            placeMarker(clickedLocation, googleMap);

            // Update form inputs - use functional update to preserve all fields including color
            setFormData(prev => ({
              ...prev,
              latitud: clickedLocation.lat.toFixed(6),
              longitud: clickedLocation.lng.toFixed(6),
            }));
          });
        }
      );
    } else {
      // Fallback if geolocation is not supported - default to Bolivia
      const boliviaCenter = { lat: -16.5000, lng: -63.6000 };
      const googleMap = new window.google.maps.Map(mapElement, {
        center: boliviaCenter,
        zoom: 6,
        mapTypeControl: true,
        streetViewControl: true,
        fullscreenControl: true,
      });
      setMap(googleMap);

      // If formData has existing coordinates, place marker there
      if (formData.latitud && formData.longitud) {
        const existingLocation = {
          lat: parseFloat(formData.latitud),
          lng: parseFloat(formData.longitud),
        };
        placeMarker(existingLocation, googleMap);
        googleMap.setCenter(existingLocation);
      }

      googleMap.addListener('click', (event) => {
        const clickedLocation = {
          lat: event.latLng.lat(),
          lng: event.latLng.lng(),
        };
        placeMarker(clickedLocation, googleMap);

        // Update form inputs - use functional update to preserve all fields including color
        setFormData(prev => ({
          ...prev,
          latitud: clickedLocation.lat.toFixed(6),
          longitud: clickedLocation.lng.toFixed(6),
        }));
      });
    }
  };

  const getMarkerIcon = (color = '#FF0000') => {
    if (!window.google || !window.google.maps) {
      return null;
    }

    // Ensure color is valid hex format
    const validColor = /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/.test(color) ? color : '#FF0000';

    // Create a custom SVG icon with the selected color
    const svgIcon = `
      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="40" viewBox="0 0 32 40">
        <path fill="${validColor}" stroke="#FFFFFF" stroke-width="2" d="M16 0C7.163 0 0 7.163 0 16c0 8.837 16 24 16 24s16-15.163 16-24C32 7.163 24.837 0 16 0z"/>
        <circle fill="#FFFFFF" cx="16" cy="16" r="6"/>
      </svg>
    `;

    return {
      url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svgIcon),
      scaledSize: new window.google.maps.Size(32, 40),
      anchor: new window.google.maps.Point(16, 40),
    };
  };

  const placeMarker = (location, mapInstance) => {
    // Remove existing marker if any (using ref for immediate access)
    if (markerRef.current) {
      markerRef.current.setMap(null);
      markerRef.current = null;
    }

    // Get color from current formDataRef (always latest value) or use default red if empty/invalid
    const currentFormData = formDataRef.current;
    let markerColor = '#FF0000'; // Default to red
    if (currentFormData?.color) {
      // Check if color is valid hex format
      if (/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/.test(currentFormData.color)) {
        markerColor = currentFormData.color;
      }
      // If invalid, keep default red
    }
    // If empty, keep default red

    // Create new marker with custom colored icon
    const newMarker = new window.google.maps.Marker({
      position: location,
      map: mapInstance,
      draggable: true,
      animation: window.google.maps.Animation.DROP,
      icon: getMarkerIcon(markerColor),
    });

    // Update marker position when dragged
    newMarker.addListener('dragend', (event) => {
      const draggedLocation = {
        lat: event.latLng.lat(),
        lng: event.latLng.lng(),
      };
      // Use functional update to preserve all fields including color
      setFormData(prev => ({
        ...prev,
        latitud: draggedLocation.lat.toFixed(6),
        longitud: draggedLocation.lng.toFixed(6),
      }));
    });

    // Store marker in both ref and state
    markerRef.current = newMarker;
    setMarker(newMarker);
  };

  useEffect(() => {
    // console.log('paisSelected');
    // console.log(paisSelected);
    if (paisSelected === null) {
      setListaCiudad([]);
      setCiudadSelected(null);
    }
  }, [paisSelected]);


  const handleInputChange = (e) => {
    const { name, value } = e.target;
    let filteredValue = value;

    // Only allow digits 0-9 for distanciaAlerta field
    if (name === "distanciaAlerta") {
      filteredValue = value.replace(/[^0-9]/g, "");
    }

    if (filteredValue.length <= charLimits[name]) {
      setFormData({
        ...formData,
        [name]: filteredValue,
      });
    }
  };

  const handleColorChange = (e) => {
    let { value } = e.target;

    // Allow empty string
    if (value === '') {
      setFormData({
        ...formData,
        color: value,
      });
      return;
    }

    // If it doesn't start with #, add it automatically
    if (!value.startsWith('#')) {
      value = '#' + value;
    }

    // Allow "#" followed by 0-6 hex characters (allows partial input while typing)
    const hexPart = value.substring(1);
    if (/^[A-Fa-f0-9]{0,6}$/.test(hexPart) && value.length <= 7) {
      setFormData({
        ...formData,
        color: value.toUpperCase(),
      });
    }
  };

  const handleColorPickerChange = (e) => {
    const { value } = e.target;
    // Color picker always returns valid hex format
    setFormData({
      ...formData,
      color: value.toUpperCase(),
    });
  };

  const handleCancelClick = () => {
    history.goBack();
  };

  const validarFormulario = () => {
    try {
      let message = "";
      if (String(formData.descripcion).trim().length === 0) {
        message = message + t("alert_debe_ingresar_descripcion") + '\n';
      }
      if (message.length > 0) {
        alert(message);
        return false;
      }
      return true;
    } catch (err) {
      console.log('validarFormulario err');
      console.log(err);
      return false;
    }
  };

  const showToast = (message, type = "warning", durationMs = 3000) => {
    setToastMessage(message);
    setToastType(type);
    setToastVisible(true);
    // Auto-hide
    window.clearTimeout(showToast._timer);
    showToast._timer = window.setTimeout(() => {
      setToastVisible(false);
    }, durationMs);
  };

  const handleSaveClick = async () => {
    // console.log('handleSaveClick');
    // lógica para guardar los cambios
    // console.log('formData');
    // console.log(formData);
    const valido = validarFormulario();
    if (valido === false) {
      return;
    }
    let distanciaAlerta = null;
    try {
      const parsed = Number(formData.distanciaAlerta);
      if (!Number.isInteger(parsed)) {
        throw ("ERROR PARSE INTEGER");
      }
      distanciaAlerta = parsed;
    } catch (err) {
      console.log('handleSaveClick err');
      console.log(err);
    }
    let objEnviar = {};
    objEnviar.id = formData.id;
    objEnviar.idGrupoCliente = grupoClienteSelected !== null ? grupoClienteSelected.value : null;
    objEnviar.idPais = paisSelected !== null ? paisSelected.value : null;
    objEnviar.idCiudad = ciudadSelected !== null ? ciudadSelected.value : null;
    objEnviar.codigo = formData.codigo;
    objEnviar.descripcion = formData.descripcion;
    objEnviar.nota = formData.nota;
    objEnviar.latitud = formData.latitud;
    objEnviar.longitud = formData.longitud;
    objEnviar.color = formData.color;
    objEnviar.telefonoCliente = rowsDataTelefonos;
    objEnviar.emailCliente = rowsDataEmail;
    objEnviar.idTipoCliente = tipoClienteSelected !== null ? tipoClienteSelected.value : null;
    objEnviar.idGeocerca = geocercaSelected !== null ? geocercaSelected.value : null;
    objEnviar.distanciaAlerta = distanciaAlerta;
    // console.log('objEnviar');
    // console.log(objEnviar);
    // return;
    setRequestSend(true);
    setProcessingVisible(true);
    try {
      if (formData.id === 0) {
        // console.log('crear correo');
        const response = await crearCliente(objEnviar);
        setProcessingVisible(false);
        // console.log('creado');
        // console.log(creado);
        if (response.error === false) {
          showToast(t("alert_se_creo_correctamente"));
          handleCancelClick();
        }
        if (response.error === true) {
          showToast(t("alert_no_se_pudo_crear"));
        }
      }
      if (formData.id !== 0) {
        // console.log('actualizar correo');
        const response = await actualizarCliente(objEnviar);
        setProcessingVisible(false);
        // console.log('modificado');
        // console.log(modificado);
        if (response.error === false) {
          showToast(t("alert_se_modifico_correctamente"));
          handleCancelClick();
        }
        if (response.error === true) {
          showToast(t("alert_no_se_pudo_modificar"));
        }
      }
    } catch (err) {
      console.log('handleSaveClick err');
      console.log(err);
      setProcessingVisible(false);
    } finally {
      setRequestSend(false);
    }
  };

  const handleNuevoTelefonoClick = () => {
    try {
      setTelefonoFormData({
        id: (rowsDataTelefonos.length + 1) * -1,
        codigo: "",
        descripcion: "",
        nota: "",
      });
      setShowModalTelefono(true);
    } catch (err) {
      console.log('handleNuevoTelefonoClick err');
      console.log(err);
    }
  };

  const handleOnAcceptTelefono = async (data) => {
    try {
      // console.log('handleOnAcceptTelefono');
      // console.log(data);
      // console.log('formData');
      // console.log(formData);
      setShowModalTelefono(false);
      const existe = rowsDataTelefonos.find(item => item.id === data.id);
      // console.log('existe', existe);
      if (existe) {
        if (formData.id !== 0) {
          // console.log('actualizar base');
          data.idCliente = formData.id;
          setProcessingVisible(true);
          const response = await actualizarTelefonoCliente(data);
          setProcessingVisible(false);
          if (response.error === false) {
            showToast(t("alert_se_actualizo_correctamente"));
          } else {
            showToast(response.message);
            return;
          }
        }
        setRowsDataTelefonos(rowsDataTelefonos.map(item => item.id === data.id ? data : item));
      } else {
        // console.log('data agregar nuevo telefono');
        // console.log(data);
        // console.log('formData');
        // console.log(formData);
        data.idCliente = formData.id;
        const response = await agregarTelefonoCliente(data);
        if (response.error === false) {
          showToast(t("alert_se_agrego_correctamente"));
          data.habilitado = 1;
          data.id = response.idTelefono;
          data.habilitadoLabel = t("column_habilitado");
          setRowsDataTelefonos([...rowsDataTelefonos, data]);
        } else {
          showToast(response.message);
        }
      }
    } catch (err) {
      console.log('handleOnAcceptTelefono err');
      console.log(err);
    }
  };

  const handleTelefonoCancel = () => {
    setShowModalTelefono(false);
    setTelefonoFormData({
      codigo: "",
      descripcion: "",
      nota: "",
    });
  };

  const handleNuevoEmailClick = () => {
    try {
      // console.log('handleNuevoEmailClick');
      setEmailFormData({
        id: (rowsDataEmail.length + 1) * -1,
        codigo: "",
        descripcion: "",
        nota: "",
      });
      setShowModalEmail(true);
    } catch (err) {
      console.log('handleNuevoEmailClick err');
      console.log(err);
    }
  };

  const handleOnAcceptEmail = async (data) => {
    try {
      // console.log('handleOnAcceptEmail');
      // console.log(data);
      const existe = rowsDataEmail.find(item => item.id === data.id);
      if (existe) {
        if (formData.id !== 0) {
          // console.log('actualizar base');
          data.idCliente = formData.id;
          setProcessingVisible(true);
          const response = await actualizarEmailCliente(data);
          setProcessingVisible(false);
          if (response.error === false) {
            showToast(t("alert_se_actualizo_correctamente"));
          } else {
            showToast(response.message);
            return;
          }
        }
        setRowsDataEmail(rowsDataEmail.map(item => item.id === data.id ? data : item));
      } else {
        data.idCliente = formData.id;
        const response = await agregarEmailCliente(data);
        if (response.error === false) {
          showToast(t("alert_se_agrego_correctamente"));
          data.id = response.idEmail;
          data.habilitado = 1;
          data.habilitadoLabel = t("column_habilitado");
          setRowsDataEmail([...rowsDataEmail, data]);
        } else {
          showToast(response.message);
        }
      }
      setShowModalEmail(false);
    } catch (err) {
      console.log('handleOnAcceptEmail err');
      console.log(err);
    }
  };

  const handleEmailCancel = () => {
    setShowModalEmail(false);
    setEmailFormData({
      codigo: "",
      descripcion: "",
      nota: "",
    });
  };

  const render = () => {
    // console.log('render correo');
    try {
      if (cargandoPage === true) {
        return cargandoCard();
      }
      // if (cargandoPage === false && formData === null) {
      //   return (
      //     <div>
      //       <label> Sin data</label>
      //     </div>
      //   );
      // }
      return (
        <div className="max-w-7xl mx-auto px-4 lg:px-6 bg-gray-100">
          <br />
          <div className="bg-white py-6 shadow-md rounded-lg sm:px-2">
            <div className="flex items-center justify-between mb-4">
              <div>
                <div className="flex items-center gap-2">
                  <ArrowBack onClick={handleCancelClick} />
                  <h2 className="text-xl font-bold text-gray-900">{titulo}</h2>
                </div>
              </div>
            </div>
            <div className="grid grid-cols-12 gap-4">
              <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
                <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="grupo-cliente">
                  {t("label_grupo_cliente")}
                </label>
                <Select options={listaGrupoCliente}
                  isSearchable={true}
                  isClearable={true}
                  value={grupoClienteSelected}
                  onChange={(event) => setGrupoClienteSelected(event)}
                  placeholder={t("placeholder_seleccione_grupo_cliente")}
                />
              </div>
              <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
                <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="pais">
                  {t("label_pais")}
                </label>
                <Select options={listaPais}
                  isSearchable={true}
                  isClearable={true}
                  value={paisSelected}
                  onChange={(event) => setPaisSelected(event)}
                  placeholder={t("placeholder_seleccione_pais")}
                />
              </div>
              <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
                <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="ciudad">
                  {t("label_ciudad")}
                </label>
                <Select options={listaCiudad}
                  isSearchable={true}
                  isClearable={true}
                  value={ciudadSelected}
                  onChange={(event) => setCiudadSelected(event)}
                  placeholder={t("placeholder_seleccione_ciudad")}
                />
              </div>
            </div>
            <br />
            <div className="grid grid-cols-12 gap-4">
              <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
                <label
                  htmlFor="codigo"
                  className="block text-md font-medium text-gray-700"
                >
                  {t("label_codigo")}
                </label>
                <input
                  id="codigo"
                  name="codigo"
                  type="text"
                  value={formData.codigo}
                  onChange={handleInputChange}

                  className={ESTILO_INPUT_GENERICO}
                  required
                  maxLength={charLimits.codigo}
                  placeholder={t("placeholder_ingresa_codigo")}
                />
                <p className="text-sm text-gray-500 flex justify-end">{formData.codigo.length}/{charLimits.codigo}</p>
              </div>
              <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
                <label
                  htmlFor="nombre"
                  className="block text-md font-medium text-gray-700"
                >
                  {t("label_descripcion")}<span className="text-red-500">*</span>
                </label>
                <input
                  id="descripcion"
                  name="descripcion"
                  type="text"
                  value={formData.descripcion}
                  onChange={handleInputChange}

                  className={ESTILO_INPUT_GENERICO}
                  required
                  maxLength={charLimits.descripcion}
                  placeholder={t("placeholder_ingresa_descripcion")}
                />
                <p className="text-sm text-gray-500 flex justify-end">{formData.descripcion.length}/{charLimits.descripcion}</p>
              </div>
              <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
                <label
                  htmlFor="nota"
                  className="block text-md font-medium text-gray-700"
                >
                  {t("label_nota")}
                </label>
                <textarea
                  id="nota"
                  name="nota"
                  type="text"
                  value={formData.nota}
                  onChange={handleInputChange}

                  className={ESTILO_INPUT_GENERICO}
                  required
                  maxLength={charLimits.nota}
                  placeholder={t("placeholder_ingresa_nota")}
                  rows={5}
                />
                <p className="text-sm text-gray-500 flex justify-end">{formData.nota?.length}/{charLimits.nota}</p>
              </div>
            </div>
            {/* lat lng */}
            <div className="grid grid-cols-12 gap-4">
              <div className="col-span-12 md:col-span-12 lg:col-span-4 xl:col-span-4">
                <>
                  <label
                    htmlFor="latitud"
                    className="block text-md font-medium text-gray-700"
                  >
                    {t("label_latitud")}
                  </label>
                  <input
                    id="latitud"
                    name="latitud"
                    type="text"
                    value={formData.latitud}
                    onChange={handleInputChange}

                    className={ESTILO_INPUT_GENERICO}
                    required
                    maxLength={charLimits.latitud}
                    placeholder={t("placeholder_ingresa_latitud")}
                  />
                  <p className="text-sm text-gray-500 flex justify-end">{formData?.latitud?.length}/{charLimits.latitud}</p>
                  <label
                    htmlFor="longitud"
                    className="block text-md font-medium text-gray-700"
                  >
                    {t("label_longitud")}
                  </label>
                  <input
                    id="longitud"
                    name="longitud"
                    type="text"
                    value={formData.longitud}
                    onChange={handleInputChange}

                    className={ESTILO_INPUT_GENERICO}
                    required
                    maxLength={charLimits.longitud}
                    placeholder={t("placeholder_ingresa_longitud")}
                  />
                  <p className="text-sm text-gray-500 flex justify-end">{formData?.longitud?.length}/{charLimits.longitud}</p>
                  <label
                    htmlFor="color"
                    className="block text-md font-medium text-gray-700 mb-2"
                  >
                    {t("label_color")}
                  </label>
                  <div className="flex gap-2 items-center">
                    <input
                      id="color"
                      name="color"
                      type="text"
                      value={formData.color || '#000000'}
                      onChange={handleColorChange}
                      className={ESTILO_INPUT_GENERICO}
                      placeholder="#FF00FF"
                      maxLength={7}
                    />
                    <input
                      type="color"
                      value={formData.color || '#000000'}
                      onChange={handleColorPickerChange}
                      className="h-10 w-16 cursor-pointer border border-gray-300 rounded"
                      title={t("label_seleccionar_color")}
                    />
                  </div>
                  <p className="text-sm text-gray-500 flex justify-end">{formData?.color?.length}/{charLimits.color}</p>
                  {formData.color && !/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/.test(formData.color) && (
                    <p className="text-sm text-red-500 mt-1">
                      {t("alert_formato_color_invalido")}
                    </p>
                  )}

                  <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="tipo-cliente">
                    {t("label_tipo_cliente")}
                  </label>
                  <Select options={listaTipoCliente}
                    isSearchable={true}
                    isClearable={true}
                    value={tipoClienteSelected}
                    onChange={(event) => setTipoClienteSelected(event)}
                    placeholder={t("placeholder_seleccione_tipo_cliente")}
                  />

                  <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="geocerca">
                    {t("label_geocerca")}
                  </label>
                  <Select options={listaGeocercas}
                    isSearchable={true}
                    isClearable={true}
                    value={geocercaSelected}
                    onChange={(event) => setGeocercaSelected(event)}
                    placeholder={t("placeholder_seleccione_geocerca")}
                  />
                </>
              </div>
              <div className="col-span-12 md:col-span-12 lg:col-span-8 xl:col-span-8">
                <label
                  htmlFor="mapa"
                  className="block text-md font-medium text-gray-700 mb-0"
                >
                  {t("label_mapa")}
                </label>
                <div
                  id="mapa"
                  className="w-full h-96 border border-gray-300 rounded-lg"
                  style={{ minHeight: '400px' }}
                ></div>
              </div>
            </div>
            <div className="grid grid-cols-12 gap-4 mt-4">
              <div className="col-span-12 md:col-span-12 lg:col-span-4 xl:col-span-4">
                <label
                  htmlFor="distanciaAlerta"
                  className="block text-md font-medium text-gray-700"
                >
                  {t("label_distancia_alerta")}
                </label>
                <div className="flex items-center gap-2">
                  <input
                    id="distanciaAlerta"
                    name="distanciaAlerta"
                    type="text"
                    inputMode="numeric"
                    pattern="[0-9]*"
                    value={formData.distanciaAlerta}
                    onChange={handleInputChange}
                    className={ESTILO_INPUT_GENERICO}
                    maxLength={charLimits.distanciaAlerta}
                    placeholder={t("placeholder_ingresa_distancia_alerta")}
                  />
                  <span className="text-sm font-medium text-gray-700 shrink-0">KM</span>
                </div>
                <p className="text-sm text-gray-500 flex justify-end">{formData?.distanciaAlerta?.length}/{charLimits.distanciaAlerta}</p>
              </div>
            </div>
            <br />
            {/* Grid Card Telefonos */}
            <div className="grid grid-cols-12 gap-4">
              <div className="col-span-12 md:col-span-12 lg:col-span-12 xl:col-span-12">
                <div className="flex justify-between items-center">
                  <label className="block text-md font-medium text-gray-700" htmlFor="gridContainerTelefonos">
                    {t("label_telefonos")}
                  </label>
                  <button
                    type="button"
                    className={ESTILO_BOTON_LISTAR_NUEVO}
                    onClick={() => {
                      handleNuevoTelefonoClick();
                    }}
                  >
                    {t("label_nuevo")}
                  </button>
                </div>
              </div>
              <div className="col-span-12 md:col-span-12 lg:col-span-12 xl:col-span-12">
                <div className="bg-white border border-gray-200 rounded-lg">
                  <div style={{ height: "400px", overflow: "scroll" }}>
                    <div
                      id="gridContainerTelefonos"
                      style={{
                        height: "100%",
                        width: "100%",
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
            <br />
            {/* Grid Card Email */}
            <div className="grid grid-cols-12 gap-4">
              <div className="col-span-12 md:col-span-12 lg:col-span-12 xl:col-span-12">
                <div className="flex justify-between items-center">
                  <label className="block text-md font-medium text-gray-700" htmlFor="gridContainerEmail">
                    {t("label_email")}
                  </label>
                  <button
                    type="button"
                    className={ESTILO_BOTON_LISTAR_NUEVO}
                    onClick={() => {
                      handleNuevoEmailClick();
                    }}
                  >
                    {t("label_nuevo")}
                  </button>
                </div>
              </div>
              <div className="col-span-12 md:col-span-12 lg:col-span-12 xl:col-span-12">
                <div className="bg-white border border-gray-200 rounded-lg">
                  <div style={{ height: "400px", overflow: "scroll" }}>
                    <div
                      id="gridContainerEmail"
                      style={{
                        height: "100%",
                        width: "100%",
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
            <br />
            <div className="grid grid-cols-12 gap-4">
              <div className="col-span-12 md:col-span-12 lg:col-span-12 xl:col-span-12">
                <div className="flex justify-between">
                  <button
                    type="button"
                    className={ESTILO_BOTON_GENERAL_CANCELAR}
                    onClick={handleCancelClick}
                  >
                    {t("label_cancelar")}
                  </button>
                  {requestSend === false && (
                    <button
                      type="button"
                      className={ESTILO_BOTON_GENERAL_ACEPTAR}
                      onClick={handleSaveClick}
                    >
                      {t("label_aceptar")}
                    </button>
                  )}
                  {requestSend === true && (
                    <button
                      type="button"
                      className={ESTILO_BOTON_GENERAL_ACEPTAR}
                      disabled
                    >
                      <div className="flex items-center justify-center gap-2">
                        <Spinner size="md" color="white" />
                      </div>
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
          <ProcessingDialog visible={processingVisible} message={t("alert_procesando_solicitud")} />
          <ToastComponent
            visible={toastVisible}
            message={toastMessage}
            type={toastType}
            onClose={() => setToastVisible(false)}
          />
          <ModalTelefono
            isOpen={showModalTelefono}
            formData={telefonoFormData}
            setFormData={setTelefonoFormData}
            onAccept={handleOnAcceptTelefono}
            onCancel={handleTelefonoCancel}
          />
          <ModalEmail
            isOpen={showModalEmail}
            formData={emailFormData}
            setFormData={setEmailFormData}
            onAccept={handleOnAcceptEmail}
            onCancel={handleEmailCancel}
          />
        </div>
      );
    } catch (err) {
      console.log('formData render err');
      console.log(err);
      return (
        <div>
          <label>{JSON.stringify(err)}</label>
        </div>
      );
    }
  }

  return render();
}
